import { render, staticRenderFns } from "./Caspian.vue?vue&type=template&id=ecab8548"
import script from "./Caspian.vue?vue&type=script&lang=js"
export * from "./Caspian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports